import { render, staticRenderFns } from "./RadioInputAltImage.vue?vue&type=template&id=73035272&"
import script from "./RadioInputAltImage.vue?vue&type=script&lang=js&"
export * from "./RadioInputAltImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports